import { ThesaurusOfflineDataFetcher } from '@skinsoft/data-store';
import { EntityDataStore } from '@skinsoft/entity-data-store';

export interface Thesaurus {
    id: string;
}

export class ThesaurusDataStore extends EntityDataStore<Thesaurus> {
    public static getInstance() {
        if (!ThesaurusDataStore.instance) {
            ThesaurusDataStore.instance = new ThesaurusDataStore();
        }

        return ThesaurusDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$thesaurusDataStore = ThesaurusDataStore.getInstance();
    }

    private static instance: ThesaurusDataStore = null as any;

    constructor() {
        super('thesaurus/identifier', ['thesaurus']);
    }

    protected initializeDataFetcher() {
        this.offlineDataFetcher = new ThesaurusOfflineDataFetcher("thesaurus")
    }
}
